module.exports = __webpack_public_path__ + "media/images/features/universal_and_inclusive_img-c750c7390acb072bef85260d5f90d102.png";